import React, { useEffect } from 'react';
import { PopupMessageContent, PopupEnum } from '../Constant/Constant';
import { connect } from 'react-redux';
import { setShowPopUp, setSimResponsibilities } from '../OwnershipTransferBuyerSlice';
import EpiContext from '@episerver/spa-core/Spa';
import Config from 'app/Config';
import MessagePopup from './MessagePopup';
import { serviceData } from '../Constant/ServiceFormText';
import ServiceAccessForm from '../../../Shared/ServiceAccessForm/ServiceAccessForm';

const OwnershipTransferBuyerPopupWrapper = (props) => {

  const popupActions = {
    closePopup: () => props.setShowPopUp(false),
    setSimResponsibilities: () => props.setSimResponsibilities(true)
  };

  let currentPopUp = () => {
    switch (props.data.currentPopUp) {
      case PopupEnum.ServiceFormPopup:
        return <ServiceAccessForm setShowPopUp={props.setShowPopUp} serviceData={serviceData} defaultOpenServices={['GIS8']} />;
      case PopupEnum.MessagePopup:
        return (
          <MessagePopup popupData={props.data.currentPopupData}
            buttonClick={popupActions[props.data.currentPopupData.buttonClick]}
            secondButtonClick={popupActions[props.data.currentPopupData.secondButtonClick]} />
        );
      default:
        break;
    }
  };

  return <div>{currentPopUp()}</div>;
};
const mapStateToProps = (state) => ({
  data: state.OwnershipTransferPrivateBuyer,
});

const mapDispatchToProps = { setShowPopUp, setSimResponsibilities };

export default connect(mapStateToProps, mapDispatchToProps)(OwnershipTransferBuyerPopupWrapper);
